//import './public-path'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/display.css'
// monaco-editor 0.5x ESM 版本不随 JS 注入样式，缺失时编辑器渲染为空白；全局引入一次供所有使用处（定时任务/代码生成器等）共享
import 'monaco-editor/min/vs/editor/editor.main.css'
import { createApp } from 'vue'
import sass from './sass'
import i18n from './locales'
import router from './router'
import store from './store'
import App from './App.vue'
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(sass)
app.mount('#app')
